import { Button, Col, Row } from "react-bootstrap";
import EpaCard from "../../../../leap-components/EpaCard";
import EpaField from "../../../../leap-components/EpaField";
import { faHourglassEnd, faRssSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { IAbstractionDetails } from "../../../../api/Abstractions/IAbstractions";
import { formatDate } from "../../../../api/DateUtils";
import {
  GetSubmissionUrl,
  GetLeapRssUrl,
  GetObservationUrl,
} from "../../../../external-apps/Config";

var foreGroundColor = "#014891";
var backGroundColor = "#FFA500"; //Orange

interface AbstractionDetailsProps {
  abstractionDetails: IAbstractionDetails;
}

const MakeASubmission = ({ abstractionDetails }: AbstractionDetailsProps) => {
  const isVisible = abstractionDetails.openforsubmissions === 1;
  return (
    <div
      className="p-3"
      style={{ visibility: isVisible ? "visible" : "hidden" }}
    >
      <a
        href={GetSubmissionUrl(abstractionDetails.registernumber)}
        target="_blank"
        rel={abstractionDetails.registernumber}
        className="btn btn-primary"
      >
        <button>Make a Submission</button>
      </a>
    </div>
  );
};

const MakeAObservation = ({ abstractionDetails }: AbstractionDetailsProps) => {
  const isVisible = abstractionDetails.openforsubmissions === 2;
  return (
    <div
      className="p-3"
      style={{ visibility: isVisible ? "visible" : "hidden" }}
    >
      <a
        href={GetObservationUrl(abstractionDetails.registernumber)}
        target="_blank"
        rel={abstractionDetails.registernumber}
        className="btn btn-primary"
      >
        <button>Make an Observation</button>
      </a>
    </div>
  );
};

const AbstractionFields = ({ abstractionDetails }: AbstractionDetailsProps) => {
  var bodyElements = (
    <div>
      <Row>
        <Col className="col-12 col-md-6">
          <EpaField
            label={"Registration Number"}
            value={
              <a href={GetLeapRssUrl(abstractionDetails.registernumber)}>
                {abstractionDetails.registernumber}
                <FontAwesomeIcon
                  style={{ color: backGroundColor }}
                  className="fas fa-stack-2x icon-background"
                  icon={faRssSquare}
                />
              </a>
            }
          />
          <EpaField
            label={"Organisation"}
            value={abstractionDetails.organisationname}
          />
          <EpaField
            label={"Site Address"}
            value={abstractionDetails.sitecomputedaddress}
          />
          <EpaField
            label={"Abstraction Purpose"}
            value={abstractionDetails.abstractionpurpose}
          />
          <EpaField label={"County"} value={abstractionDetails.county} />
        </Col>
        <Col>
          <EpaField
            label={"Date Received"}
            value={formatDate(abstractionDetails.applicationreceiveddate)}
          />

          <EpaField label={"Status"} value={abstractionDetails.licencestatus} />

          <EpaField
            label={"Issued Date"}
            value={formatDate(abstractionDetails.licenceissueddate)}
          />

          <MakeAObservation abstractionDetails={abstractionDetails} />
          <MakeASubmission abstractionDetails={abstractionDetails} />
        </Col>
      </Row>
    </div>
  ) as JSX.Element;

  return <EpaCard title={"Abstraction Details"} content={bodyElements} />;
};

export default AbstractionFields;
